(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["andcharlie-illustration"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ac-bee-motion')) {
    customElements.define('ac-bee-motion', class extends HTMLElement {
      connectedCallback() {
        this.visible = false;
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onPreference = () => this.preference.matches ? this.stop() : this.play();
        this.onVisibility = () => document.hidden ? this.stop() : this.play();
        this.preference.addEventListener('change', this.onPreference);
        document.addEventListener('visibilitychange', this.onVisibility);
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          if (this.visible) this.play();
          else this.stop();
        }, { threshold: 0 });
        this.observer.observe(this);
      }

      play() {
        if (this.motionImage || !this.visible || !this.isConnected || this.preference.matches || document.hidden) return;
        const image = new Image(144, 155);
        this.motionImage = image;
        image.alt = '';
        image.className = 'ac-illustration__moving';
        image.onload = () => {
          if (this.motionImage !== image || !this.isConnected || !this.visible || this.preference.matches || document.hidden) return;
          this.append(image);
          this.classList.add('is-playing');
        };
        image.onerror = () => this.stop();
        image.src = this.dataset.motionSrc;
      }

      stop() {
        this.classList.remove('is-playing');
        if (this.motionImage) {
          this.motionImage.onload = null;
          this.motionImage.onerror = null;
          this.motionImage.remove();
          this.motionImage = null;
        }
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        this.preference?.removeEventListener('change', this.onPreference);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
